import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Title } from '@/components/atoms/Title/Title';
import { useGetMfaMethodsQuery } from '@/services/innovorder/auth/auth.endpoints';
import { getUserId, getUserToken } from '@/redux/user/user.slice';

import { Container, Header } from './Security.style';
import IpAllowlistSection from './sections/IpAllowlistSection';
import PasskeySection from './sections/PasskeySection';
import TotpSection from './sections/TotpSection';

const Security = (): ReactElement | null => {
    const userId = useSelector(getUserId);
    const token = useSelector(getUserToken);

    const { data, isLoading } = useGetMfaMethodsQuery(
        { token: token ?? '', userId: userId ?? 0 },
        { skip: !userId || !token },
    );

    if (!userId || !token) return null;

    return (
        <Container>
            <Header>
                <Title text="security.title" />
            </Header>

            {isLoading || !data ? (
                <p>
                    <FormattedMessage id="security.loading" />
                </p>
            ) : (
                <>
                    <TotpSection userId={userId} token={token} totp={data.totp} />
                    <PasskeySection token={token} userId={userId} credentials={data.webauthn} />
                    <IpAllowlistSection token={token} userId={userId} />
                </>
            )}
        </Container>
    );
};

export default Security;
